import { MenuItemType } from '@/types'

import cn from './ToggleMenu.module.scss'

type ToggleMenuProps = {
  current?: string
  setCurrent?: (current: string) => void
  menuItems: MenuItemType[]
}

function ToggleMenu(props: ToggleMenuProps) {
  const { menuItems, current, setCurrent } = props

  return (
    <div className={cn.menu}>
      {menuItems.map((item: MenuItemType) => (
        <div
          className={
            current == item.name
              ? [cn.menuItem, cn.active].join(' ')
              : cn.menuItem
          }
          key={item.id}
          onClick={() => (setCurrent ? setCurrent(item.name) : null)}
        >
          {item.name}
        </div>
      ))}
      <div className={`${cn.menuItem} ${cn.last}`}></div>
    </div>
  )
}

export default ToggleMenu
